<div class="app-select entity-selector">
  <div class="container">

    <div class="row">
      <div class="col-12 text-center">
        <div class="login-header text-center pt-5">
          <img src="{{ logoUrl }}" alt="logo" height="80">
        </div>
      </div>
    </div>
    <div class="row justify-content-center" [hidden]="loading">
      <div class="col-md-12 text-center mb-5">
      </div>
    </div>
    <div class="row">
      <div class="col-md-5 mx-auto">
        <div class="entity-wrapper">
          <div class="row">
            <div class="col-12 mb-5 col-md-12 col-lg-12" [hidden]="!principal.user?.roles.includes(userRolesNew.SUPER_ADMIN) && 
      !principal.user?.roles.includes(userRolesNew.ADMIN) && 
      !principal.user?.roles.includes(userRolesNew.ADMIN_READ_ONLY) && 
      !principal.user?.roles.includes(userRolesNew.USER) && 
      !principal.user?.roles.includes(userRolesNew.USER_READ_ONLY)">
              <div class="app-select-group">
                <h3 class="app-select-group-title">Main Dashboard</h3>
                @if (principal.user?.roles.includes(userRolesNew.SUPER_ADMIN) || principal.user?.roles.includes(userRolesNew.ADMIN) || principal.user?.roles.includes(userRolesNew.ADMIN_READ_ONLY) || principal.user?.roles.includes(userRolesNew.USER) || principal.user?.roles.includes(userRolesNew.USER_READ_ONLY)) {
                  <div class="mb-3 app-select-item">
                    <div class="app-select-item-row" (click)="mainDashboard()">
                      <div class="app-select-item-icon">
                        <i class="fal fa-user-tie"></i>
                      </div>
                      <div class="app-select-item-title text-uppercase">Main dashboard</div>
                      <div class="app-select-item-action">
                        <i class="fas fa-chevron-right" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                }
                @if (principal.user?.roles.includes(userRoles.CAMPAIGN_MANAGER) || principal.user?.roles.includes(userRoles.CLIENT_SERVICE_MANAGER)) {
                  <div class="mb-3 app-select-item">
                    <div class="app-select-item-row">
                      <div class="app-select-item-icon">
                        <i class="fal fa-user-tie"></i>
                      </div>
                      <div class="app-select-item-title text-uppercase">Campaigns dashboard</div>
                      <div class="app-select-item-action">
                        <i class="fas fa-chevron-right" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                }
              </div>

              @if (principal.user?.roles.includes('CONTENT_OWNER')) {
                <div class="app-select-group"
                  [ngClass]="{'mt-5': principal.user?.roles.includes('ADMIN')}">
                  <h3 class="app-select-group-title">Content owner dashboard</h3>
                  @if (coLoading) {
                    <div class="data-loader">
                      <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="30">
                      </mat-spinner>
                    </div>
                  }
                  @if (contentOwners?.length && !coLoading) {
                    <div>
                      @for (co of contentOwners; track co) {
                        <div class="mb-3 app-select-item">
                          <div class="app-select-item-row">
                            <div class="app-select-item-icon">
                              <i class="fal fa-user-tie"></i>
                            </div>
                            <div class="app-select-item-title text-uppercase">{{co.name}}</div>
                            <div class="app-select-item-action">
                              <i class="fas fa-chevron-right" aria-hidden="true"></i>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
            <div class="col-12 mb-4 col-md-12 col-lg-12"
              [hidden]="!principal.user?.publisherIds || !principal.user?.publisherIds.length">
              @if (pubLoading) {
                <div class="data-loader">
                  <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="30">
                  </mat-spinner>
                </div>
              }
              @if (!pubLoading) {
                <div class="app-select-group">
                  <h3 class="app-select-group-title">Publisher Dashboards</h3>
                  @if (publishers?.length) {
                    <div>
                      @for (p of publishers; track p) {
                        <div class="mb-3 app-select-item">
                          <div class="app-select-item-row" (click)="selectPublisher(p.id)">
                            <div class="app-select-item-icon">
                              <i class="fal fa-user"></i>
                            </div>
                            <div class="app-select-item-title text-uppercase">{{p.name}}</div>
                            <div class="app-select-item-action">
                              <i class="fas fa-chevron-right" aria-hidden="true"></i>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
            <div class="col-12 mb-4 col-md-12 col-lg-12"
              [hidden]="!principal.user?.advertiserId">
              @if (advertiserLoading) {
                <div class="data-loader">
                  <mat-spinner [color]="'primary'" [mode]="'indeterminate'" [diameter]="30">
                  </mat-spinner>
                </div>
              }
              @if (!advertiserLoading) {
                <div class="app-select-group">
                  <h3 class="app-select-group-title">Advertiser Dashboards</h3>
                  @if (advertiser.name !== '') {
                    <div>
                      <div class="mb-3 app-select-item">
                        <div class="app-select-item-row" (click)="selectAdvertiser(advertiser.id)">
                          <div class="app-select-item-icon">
                            <i class="fal fa-user"></i>
                          </div>
                          <div class="app-select-item-title text-uppercase">{{advertiser.name}}</div>
                          <div class="app-select-item-action">
                            <i class="fas fa-chevron-right" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-md-5 mx-auto">
        <small class="d-block text-center text-muted mt-5 entity-bottom3">
          © 2025 {{ platformTitle }}
        </small>
      </div>
    </div>
  </div>

</div>
